import React from 'react';

const PointerUp = (props: any) => {
  const { className, fillColor = '#919191', onClick } = props;

  return (
    (<svg
      data-testid="Zrattfez9AXdftGdPfVuR"
      className={className}
      onClick={onClick}
      width="12px"
      height="11px"
      viewBox="0 0 12 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      data-palette="PointerUp">
      <g id="dribbble" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Mobile-(OPEN)"
          transform="translate(-286.000000, -388.000000)"
          fill={fillColor}
          fillRule="nonzero"
        >
          <g
            id="Group-47"
            transform="translate(292.000000, 393.500000) rotate(180.000000) translate(-292.000000, -393.500000) translate(286.000000, 388.000000)"
          >
            <g id="noun_Download_1200004">
              <path
                d="M5.99960476,6 C5.84269293,6 5.69170976,5.94317058 5.58025098,5.84210053 L0.173709693,0.920960345 C-0.0579032311,0.710187933 -0.0579032311,0.368851722 0.173709693,0.158079309 C0.405322618,-0.0526931031 0.780409077,-0.0526931031 1.012022,0.158079309 L5.99960476,4.69759914 L10.987978,0.158438989 C11.2195909,-0.0523334233 11.5946774,-0.0523334233 11.8262903,0.158438989 C12.0579032,0.369211402 12.0579032,0.710547613 11.8262903,0.921320025 L6.41895853,5.84174085 C6.30749975,5.94317058 6.15651658,6 5.99960476,6 Z"
                id="Shape"
              />
            </g>
            <g id="noun_Download_1200004-Copy" transform="translate(0.000000, 5.000000)">
              <path
                d="M5.99960476,6 C5.84269293,6 5.69170976,5.94317058 5.58025098,5.84210053 L0.173709693,0.920960345 C-0.0579032311,0.710187933 -0.0579032311,0.368851722 0.173709693,0.158079309 C0.405322618,-0.0526931031 0.780409077,-0.0526931031 1.012022,0.158079309 L5.99960476,4.69759914 L10.987978,0.158438989 C11.2195909,-0.0523334233 11.5946774,-0.0523334233 11.8262903,0.158438989 C12.0579032,0.369211402 12.0579032,0.710547613 11.8262903,0.921320025 L6.41895853,5.84174085 C6.30749975,5.94317058 6.15651658,6 5.99960476,6 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default PointerUp;
